/*
 * Copyright (c) 2020. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';
import { ProgressCircle } from '@americanexpress/dls-react';

import Typography from '../../components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

import './WaitIcon.scss';

export default class WaitIcon extends Component<
    {
        messages: string[];
    },
    {
        loaded: boolean;
    }
> {
    public override state = {
        loaded: false
    };

    public override render(): ReactComponentElement<any> {
        return this.props.messages.length === 0 ? null : (
            <div className="bw-wait-icon">
                <div className="overlay">
                    <div className="wait">
                        <ProgressCircle />
                        <Typography variant={TypographyVariants.HEADING_XS} className="subtitle">
                            {this.props.messages[0]}
                        </Typography>
                        <Typography variant={TypographyVariants.CAPTION}>{this.props.messages[1]}</Typography>
                    </div>
                </div>
            </div>
        );
    }
}
